var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBomba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.634,
    height: 22.451,
    viewBox: "0 0 71.286 37.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1170",
    "data-name": "Grupo 1170",
    transform: "translate(-279.964 -453.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_837",
    "data-name": "Caminho 837",
    d: "M295.31,465.891h-.081a5.264,5.264,0,1,0,.081,0Z",
    transform: "translate(11.588 14.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_838",
    "data-name": "Caminho 838",
    d: "M289.327,465.9a5.166,5.166,0,1,0,5.292,5.138A5.226,5.226,0,0,0,289.327,465.9Z",
    transform: "translate(4.906 14.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_839",
    "data-name": "Caminho 839",
    d: "M310.133,465.9h-.07a5.273,5.273,0,1,0,.07,0Z",
    transform: "translate(28.448 14.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_840",
    "data-name": "Caminho 840",
    d: "M350.219,476.517h-.282V465.612a7.1,7.1,0,0,0-.248-1.953,6.619,6.619,0,0,0-6.521-4.788c-3.74-.013-7.48,0-11.232,0v-3.659a2.017,2.017,0,0,0-2.019-2.015h-46.6l-.841,3.319A2.571,2.571,0,0,1,281,458.243l-1.04.444,3.548,7.548h-2.4l3.082,5.511a1.017,1.017,0,0,0-.48.85v11.017a1.03,1.03,0,0,0,1.031,1.031h1.708c.034-.113.073-.213.1-.324a7.615,7.615,0,0,1,7.42-5.8c4.248-.023,8.5-.034,12.741,0a7.63,7.63,0,0,1,7.507,6.143h16.319c.213,0,.412.038.5-.292a7.7,7.7,0,0,1,14.942-.034c.068.265.167.333.427.331h4.572a1.956,1.956,0,0,0,.269-.038v-7.078A1.032,1.032,0,0,0,350.219,476.517Zm-58.556-18.174H309.3l-9.561,4.922-9.324-1.834Zm20.818,12.3L310.17,466.5a3.3,3.3,0,0,0-1.814-1.494l11.537-6.666h5.812v2.2a1.88,1.88,0,0,0,1.94,1.876l4.034-.126c-.137,3.552-.3,8.59-.3,8.59Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBomba);
export default __webpack_public_path__ + "static/media/bomba.c0be2a25ef64b65b3bb245145d5b410b.svg";
export { ForwardRef as ReactComponent };